// @ts-check
import React, { Component } from 'react';
import { ExternalReferringLocationField } from './ExternalReferringLocationField';
import { ExternalReferringProviderField } from './ExternalReferringProviderField';
import api from 'utils/api';

class ExternalReferringLocationAndProvider extends Component {
  constructor(props, context) {
    super(props);
    this.state = { referringLocations: null };
    this.selectReferringLocations = this.selectReferringLocations.bind(this);
  }

  selectReferringLocations(externalReferringProvider) {
    // NB: Bug in react-select that gives value of [] under certain conditions.
    // Resolving now by checking explicitly for id, don't want to upgrade right now.
    if (externalReferringProvider && externalReferringProvider.id) {
      return api
        .get(`/agent_portal/api/providers/${externalReferringProvider.id}/locations`)
        .then(response => {
          this.setState({ referringLocations: response.data });
        });
    }
  }

  render() {
    const { form } = this.props;
    return (
      <div style={{ position: 'relative', zIndex: 1 }}>
        {/* <ProviderSelectionField
          name="externalReferringProvider"
          label="Which provider sent you a Referral?"
          onChange={this.selectReferringLocations}
          className="input-xxlarge"
        /> */}
        <div id="externalReferringProvider-wrapper">
          <ExternalReferringProviderField
            form={form}
            onChange={this.selectReferringLocations}
            name="externalReferringProvider"
            label="Which provider sent you a Referral?"
          />
        </div>
        <div id="externalReferringLocationId-wrapper">
          <ExternalReferringLocationField
            form={form}
            name="externalReferringLocationId"
            label="From which location?"
            options={this.state.referringLocations}
            valueKey="id"
            labelKey="name"
          />
        </div>
        {/* <SelectField
          name="externalReferringLocationId"
          label="From which location?"
          options={this.state.referringLocations}
          valueKey="id"
          labelKey="name"
        /> */}
      </div>
    );
  }
}

export default ExternalReferringLocationAndProvider;
